import LoginForm from "../loginForms";

const LoginRight: React.FC = () => {
  return (
    <main className="w-full flex-1 md:w-1/2">
      <LoginForm />
    </main>
  );
};

export default LoginRight;
